import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

export interface UserData {
  id?: number;
  email:string
  name: string;
  firstName: string;
  lastName:string;
  role: string;
  password: string;
  token?: string | null
  is_verified?:boolean;
  phone_number?:any;
  phoneNumber?:any
  
}

interface AuthContextType {
  user?: UserData | null;
  login: (userData: UserData) => void;
  logout: () => void;
}

const initialAuthContext: AuthContextType = {
  user: null,
  login: () => {},
  logout: () => {}
}

export const AuthContext = createContext<AuthContextType>(initialAuthContext);
interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<UserData | null>(null);
  const login = (userData: UserData) => {
 
    const combinedInfo = `${userData.email}:${userData.password}`;
    const token = btoa(combinedInfo);
    setUser({ ...userData, token });
    localStorage.setItem('userData', JSON.stringify({ ...userData, token }));
  };

  const logout = () => {

    setUser(null);
    localStorage.removeItem('userData');
  };

  useEffect(() => {
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      setUser(JSON.parse(storedUserData));
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};


export const useAuth = (): AuthContextType => {

  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

 
  return context;
};
